import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { AdvancedSettingsAPI } from 'api/advanced-settings/advanced-settings';
import { SettingType } from 'api/advanced-settings/settings-types';
const baseOptions = {
    refetchOnWindowFocus: false,
    refetchOnMount: false
};
export const getQueryAdvancedSettingsConfigKey = ()=>[
        'AdvancedSettingsConfig'
    ];
export const useQueryAdvancedSettingsConfig = (options)=>useQuery(getQueryAdvancedSettingsConfigKey(), ()=>AdvancedSettingsAPI.getAdvancedSettingsConfig(), {
        ...baseOptions,
        ...options
    });
export const useMutateAdvancedSettingsConfig = ()=>{
    const queryClient = useQueryClient();
    return useMutation((data)=>AdvancedSettingsAPI.updateAdvancedSettingsConfig(data), {
        onMutate: async (updatedSetting)=>{
            var _queryClient_getQueryData;
            const previousSettings = (_queryClient_getQueryData = queryClient.getQueryData(getQueryAdvancedSettingsConfigKey())) !== null && _queryClient_getQueryData !== void 0 ? _queryClient_getQueryData : [];
            const filteredSettings = previousSettings.filter((setting)=>setting.eventType !== updatedSetting.eventType);
            await queryClient.setQueryData(getQueryAdvancedSettingsConfigKey(), [
                ...filteredSettings,
                updatedSetting
            ]);
            return previousSettings;
        },
        onError: async (err, _, context)=>{
            await queryClient.setQueryData(getQueryAdvancedSettingsConfigKey(), context);
        }
    });
};
export const getAlignPhaseDatesSetting = (settings)=>{
    var _settings_find;
    return (settings === null || settings === void 0 ? void 0 : (_settings_find = settings.find(({ eventType })=>eventType === SettingType.AlignPhaseDates)) === null || _settings_find === void 0 ? void 0 : _settings_find.eventValue) || false;
};
export const getNewDependenciesEnabledSetting = (settings)=>{
    var _settings_find;
    return (settings === null || settings === void 0 ? void 0 : (_settings_find = settings.find(({ eventType })=>eventType === SettingType.EnableNewDependenciesAndLag)) === null || _settings_find === void 0 ? void 0 : _settings_find.eventValue) || false;
};
export const getManualPhaseSequencingSetting = (settings)=>{
    var _settings_find;
    return (settings === null || settings === void 0 ? void 0 : (_settings_find = settings.find(({ eventType })=>eventType === SettingType.ManualPhaseSequencing)) === null || _settings_find === void 0 ? void 0 : _settings_find.eventValue) || false;
};
export const useGetAlignPhaseDatesSetting = ()=>{
    const { data: advancedSettingsConfig = [] } = useQueryAdvancedSettingsConfig();
    return useMemo(()=>getAlignPhaseDatesSetting(advancedSettingsConfig), [
        advancedSettingsConfig
    ]);
};
export const useGetManualPhaseSequencingSetting = ()=>{
    const { data: advancedSettingsConfig = [] } = useQueryAdvancedSettingsConfig();
    return useMemo(()=>getManualPhaseSequencingSetting(advancedSettingsConfig), [
        advancedSettingsConfig
    ]);
};
export const useGetNewDependenciesEnabledSetting = ()=>{
    const { data: advancedSettingsConfig = [] } = useQueryAdvancedSettingsConfig();
    return useMemo(()=>{
        var _advancedSettingsConfig_find;
        return ((_advancedSettingsConfig_find = advancedSettingsConfig.find(({ eventType })=>eventType === SettingType.EnableNewDependenciesAndLag)) === null || _advancedSettingsConfig_find === void 0 ? void 0 : _advancedSettingsConfig_find.eventValue) || false;
    }, [
        advancedSettingsConfig
    ]);
};
